import React from 'react';
import { getConfig } from '../../appConfig';
import { NormalText, Spacer } from '../common';
import './index.css';

const OrderCustomMessage = ({ __, orderType }) => {
	const message = getConfig().general.orderCustomMessage?.[orderType];

	if (!message) {
		return null;
	}

	return (
		<>
			<div className="box-content">
				<NormalText className="order-custom-message-text">{__(message)}</NormalText>
			</div>
			<Spacer size={2} />
		</>
	);
};

export default OrderCustomMessage;
